import React, { useContext } from 'react';

import { PageBuilder } from 'src/components/PageBuilder';

import classes from './AppShell.scss';
import { ConfigContext } from './ConfigProvider';

export function GlobalBanner() {
    const { cmsBlocks } = useContext(ConfigContext);
    if (!cmsBlocks.globalBanner) return null;
    return (
        <div className={classes.banner}>
            <PageBuilder html={cmsBlocks.globalBanner} />
        </div>
    );
}
